import { staticText } from '../../utils/translations/staticText';

export const ApprovalOddsTranslations = staticText({
  approval_odds: {
    _: 'Approval Odds',
    zh: '批核機會',
  },
  approval_odds_tooltip: {
    _: 'Approval chances are estimated based on data from users with a similar credit profile. This is indicative only and does not guarantee approval or rejection.',
    zh: '批核機會根據與您相似信貸狀況的用戶數據估算，僅供參考，不保證獲批或被拒。',
  },
  approval_odds_last_updated: {
    _: 'Last updated',
    zh: '最後更新',
  },
  approval_odds_high: {
    _: 'High',
    zh: '高',
  },
  approval_odds_medium: {
    _: 'Medium',
    zh: '中',
  },
  approval_odds_low: {
    _: 'Low',
    zh: '低',
  },
  approval_odds_unlock: {
    _: 'Unlock',
    zh: '解鎖',
  },
});
